import {FormGroup, ValidatorFn} from "@angular/forms";

export function MatchValidator(
  controlName: string,
  matchingControlName: string,
  formGroupName: string = null
): ValidatorFn {
  return (formGroup: FormGroup) => {
    let control = formGroup.controls[controlName];
    if (!control) {
      const parent = formGroup.controls[formGroupName] as FormGroup;
      control = parent.controls[controlName];
    }

    let matchingControl = formGroup.controls[matchingControlName];
    if (!matchingControl) {
      const parent = formGroup.controls[formGroupName] as FormGroup;
      matchingControl = parent.controls[matchingControlName];
    }

    if (!control || !matchingControl) {
      return null;
    }

    const currentErrors = {...(matchingControl.errors || {})};

    if (!matchingControl.value) {
      delete currentErrors.mustMatch;
      matchingControl.setErrors(Object.keys(currentErrors).length ? currentErrors : null);
      return null;
    }

    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({...currentErrors, mustMatch: true});
    } else {
      delete currentErrors.mustMatch;
      matchingControl.setErrors(Object.keys(currentErrors).length ? currentErrors : null);
    }

    return null;
  };
}
